// extracted by mini-css-extract-plugin
export default {"fsl":"IncodeCaptureFSL-module__fsl-O7XI"};